import { env } from '@/core/environments'

/**
 * Get the current application build type, prioritizing Vite environment variables
 * over environment configuration.
 *
 * Used to determine which whitelabel configuration to use.
 */
export const getBuildType = (): 'brandtrack' | 'musicbrand' | 'ibiza_songs' => {
	// First try to get from explicit Vite environment variables
	const viteBuildType = import.meta.env.VITE_BUILD_TYPE as string | undefined
	const viteMode = import.meta.env.MODE as string | undefined

	if (viteBuildType) {
		if (viteBuildType === 'musicbrand') return 'musicbrand'
		if (viteBuildType === 'ibiza_songs') return 'ibiza_songs'
		if (viteBuildType === 'brandtrack') return 'brandtrack'
	}

	// Fall back to the active Vite mode for whitelabel builds
	if (viteMode) {
		if (viteMode === 'musicbrand') return 'musicbrand'
		if (viteMode === 'ibiza_songs') return 'ibiza_songs'
		if (viteMode === 'brandtrack') return 'brandtrack'
	}

	// Fallback to environment configuration
	return (env.BUILD_TYPE || 'brandtrack') as
		| 'brandtrack'
		| 'musicbrand'
		| 'ibiza_songs'
}

/**
 * Check if the current build is a partner/whitelabel build
 */
export const isPartnerBuild = (): boolean => {
	return getBuildType() !== 'brandtrack'
}
